import { createAction, props } from '@ngrx/store'
import { PlayerComparisonRequest, PlayerRequest, PlayerSummary } from '@core/models/player.models'
import { Aggregation } from '@features/aggregations/models/aggregations.models'

export const fetchPlayerMetricsFinderData = createAction('[MetricFinder] fetch player metrics data')

export const fetchFavTeamPlayerMetrics = createAction(
  '[MetricFinder] fetch fav player metrics',
  props<{
    seasonId: string
    competitionId: string
    teamId: string
    playerId: string
    playerPosition: string
    leftAggregationDataSource: Aggregation
    aggregationDataSource: Aggregation
  }>()
)
export const fetchPlayerMetrics = createAction(
  '[MetricFinder] fetch player metrics',
  props<{
    player: PlayerSummary
  }>()
)
export const fetchPlayerComparisonMetrics = createAction(
  '[MetricFinder] fetch player comparison metrics',
  props<{
    players: PlayerComparisonRequest
  }>()
)
export const fetchMatchPlayerMetrics = createAction('[MetricFinder] fetch match player metrics', props<PlayerRequest>())
export const fetchMatchPlayerComparisonMetrics = createAction(
  '[MetricFinder] fetch match player comparison metrics',
  props<{
    matchId: string
    comparison: PlayerComparisonRequest
    position: string
  }>()
)
